import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#FFAB66",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#622A76",
    },
    error: {
      main: "#CF101F",
    },
    success: {
      main: "#42B883",
    },
    info: {
      main: "#4D86F4",
    },
    warning: {
      main: "#FF8A00",
    },
    text: {
      primary: "#242424",
      secondary: "#606062",
    },
    background: {
      default: "#E5E5E5",
    },
  },
  typography: {
    fontFamily: [
      "Roboto",
      "Source Sans Pro",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Arial",
      '"Helvetica Neue"',
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default theme;
